export default __webpack_public_path__ + "static/media/filter-icon.a96b9720.svg";